import React from "react";

import TicketHeader from "./TicketHeader";
import PDFViewer from "./../PDFViewer.js";

const Ticket = ({
  ticketid = "",
  workflowtype = "",
  assignedto = "",
  priority = "",
  subject = "",
  creationdate = new Date(),
  signedURL,
  lob,
  status,
  dcn,
}) => {
  const isPdf = (fileName) => {
    return fileName && fileName.toLowerCase().includes(".pdf");
  };

  return (
    <div>
      <TicketHeader
        ticketId={ticketid}
        type={workflowtype}
        subject={subject}
        assignee={assignedto}
        createadAt={creationdate}
        lob={lob}
        dcn={dcn}
        status={status}
      />
      {signedURL && isPdf(signedURL) && <PDFViewer doc={signedURL} />}
    </div>
  );
};

export default Ticket;
